var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
import BCard from "bootstrap-vue/es/components/card/card";
import Background from "./Background.vue";
var Card = /** @class */ (function (_super) {
    __extends(Card, _super);
    function Card() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Prop({ type: String })
    ], Card.prototype, "title", void 0);
    __decorate([
        Prop({ type: String })
    ], Card.prototype, "subtitle", void 0);
    __decorate([
        Prop({ type: String })
    ], Card.prototype, "badge", void 0);
    __decorate([
        Prop({ type: String })
    ], Card.prototype, "content", void 0);
    __decorate([
        Prop({ type: String })
    ], Card.prototype, "footer", void 0);
    __decorate([
        Prop({ type: String })
    ], Card.prototype, "downloadLink", void 0);
    __decorate([
        Prop({ type: String })
    ], Card.prototype, "contentLink", void 0);
    __decorate([
        Prop({ type: String })
    ], Card.prototype, "externalLink", void 0);
    __decorate([
        Prop({ type: String })
    ], Card.prototype, "externalLinkText", void 0);
    __decorate([
        Prop({ type: Object })
    ], Card.prototype, "background", void 0);
    Card = __decorate([
        Component({
            name: "Card",
            components: {
                "b-card": BCard,
                Background: Background
            }
        })
    ], Card);
    return Card;
}(Vue));
export default Card;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Components/Card.vue
// module id = 64
// module chunks = 0 1 5 7 8 9 11